<div class="relative min-w-0">
  <button
    type="button"
    class="filter-button"
    [ngClass]="{
      'border-blue-400 bg-white text-black': isOpen(),
      'border-gray-400 bg-white text-black hover:border-gray-700 hover:bg-gray-50':
        !isOpen(),
    }"
    [class.opacity-50]="disabled"
    [attr.aria-expanded]="isOpen()"
    (click)="toggle($event)"
  >
    <mat-icon
      class="flex! h-4! w-4! items-center! justify-center! text-base!"
      aria-hidden="true"
    >
      calendar_today
    </mat-icon>
    <span class="min-w-0 truncate">{{ selectedLabel }}</span>
    <mat-icon
      class="flex! h-4! w-4! items-center! justify-center! text-base!"
      aria-hidden="true"
    >
      {{ isOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}
    </mat-icon>
  </button>

  @if (isOpen()) {
    <div
      class="comcast-select-panel min-w-48"
      [class.comcast-select-panel--open]="isOpen()"
      role="listbox"
      aria-label="Date range options"
      (click)="$event.stopPropagation()"
      (keydown.escape)="isOpen.set(false)"
    >
      <div class="comcast-select-options">
        @for (option of optionList; track option.value) {
          <button
            type="button"
            class="comcast-select-option w-full text-left"
            [class.comcast-select-option--selected]="selectedOption === option.value"
            role="option"
            [attr.aria-selected]="selectedOption === option.value"
            (click)="select(option.value, $event)"
          >
            {{ option.viewValue }}
          </button>
        }
      </div>
    </div>
  }
</div>
